<template>
  <home-layout>
    <template slot="col-left">
      <home-message />
    </template>
    <div class="main-title">
      Encuentra aquí las alternativas de educación superior
    </div>
    <div class="main-tagline">
      Escoge una opción para comenzar
    </div>
    <a
      class="card"
      href="https://informacion-educacion-superior.exploratufuturo.org/"
    >
      <div class="card-container">
        <img
          src="../assets/card-arrow.svg"
          class="card-arrow"
        >
        <div class="icon">
          <img
            class="normal"
            src="../assets/group-2283.svg"
          >
          <img
            class="hover"
            src="../assets/group-2283-white.svg"
          >
        </div>
        <div class="card-text">
          <div class="card-heading">BUSCAR INFORMACIÓN DE CARRERAS</div>
          <div
            class="card-description"
          >Consulta los datos más relevantes de las carreras disponibles en República Dominicana</div>
        </div>
      </div>
    </a>

    <div
      class="card"
      @click="$router.push('/explorar_carreras')"
    >
      <div class="card-container">
        <img
          src="../assets/card-arrow.svg"
          class="card-arrow"
        >

        <div class="icon">
          <img
            class="normal"
            src="../assets/path-2007.svg"
          >
          <img
            class="hover"
            src="../assets/path-2007-white.svg"
          >
        </div>
        <div class="card-text">
          <div class="card-heading">
            EXPLORAR CARRERAS
          </div>
          <div
            class="card-description"
          >
            Conoce las carreras y universidades disponibles compatibles con tu perfil estudiantil
          </div>
        </div>
      </div>
    </div>
  </home-layout>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import { authenticationService, trackingService } from '../_services';
import store from '../_store';

export default {
    name: 'Home',
    data() {
        return {};
    },
    computed: {
        accessRoute() {
            return { name: 'home' };
        },
        exploreRoute() {
            return { name: 'explorar carreras' };
        },
    },
    mounted() {
        const visitorUuid = uuidv4();
        window.localStorage.setItem('visitor_uuid', visitorUuid);
        trackingService.new_visit_tracks(visitorUuid);

        store.commit('authentication/logout');
        authenticationService.logout();
    },
    methods: {},
};
</script>
<style lang="scss" scoped>

.card-arrow {
  width: 28px;
  height: 28px;
  position: absolute;
  bottom: 10px;
  opacity: 0;
  transition: all;
  @media screen and (min-width: 800px) {
    bottom: inherit !important;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.icon {
  width: 153px;
  height: 153px;
  border-radius: 7px;
  border: solid 3px #9bc8f2;
  display: flex;
  align-content: center;
  justify-content: center;
  transition: all 0.2s;
  margin-bottom: 1rem;

  img{
    width: 50px;
    @media screen and (min-width: 660px) {
      width: 38px;
    }
  }
  .hover{
    display: none;
  }

  @media screen and (min-width: 660px) {
    width: 90px;
    height: 90px;
  }
}
.card {
  &:hover {
    .icon {
      background-color: #2e89df;
      border-color: #2e89df;
      .normal{
        display: none;
      }
      .hover{
        display: block;
      }
    }
  }
}
.main-title {
  display: none;
  font-family: "Roboto", sans-serif;
  font-size: 1.75rem;
  font-weight: 900;
  line-height: 1.36;
  color: #0a2139;
  @media screen and (min-width: 660px) {
    display: block !important;
  }
}
.main-tagline {
  display: none;
  font-family: "Roboto", sans-serif;
  font-size: 1.875rem;
  font-weight: 500;
  line-height: 1.37;
  color: #0a2139;
  margin-bottom: 62px;

  @media screen and (min-width: 660px) {
    display: block !important;
    font-size: 1.125rem;
  }
}
</style>
